/**
 * The default amount of time in miliseconds to wait before removing a toast.
 */
export const DEFAULT_TIMEOUT = 5000;

/**
 * The default margin between toasts.
 */
export const TOAST_MARGIN = 12;

/**
 * The data attribute attached to the tray element to indicate its vertical position.
 */
export const VERTICAL_DATA_ATTRIBUTE = 'data-vertical-position';

/**
 * A map of all available vertical tray values.
 */
export const VERTICAL_VALUES = {
    TOP: 'top',
    BOTTOM: 'bottom'
};

/**
 * The data attribute attached to the tray element to indicate its horizontal position.
 */
export const HORIZONTAL_DATA_ATTRIBUTE = 'data-horizontal-position';

/**
 * A map of all available horizontal tray values.
 */
export const HORIZONTAL_VALUES = {
    CENTER: 'center',
    EDGE: 'edge'
};

/**
 * The error thrown when the toast's content wasn't passed.
 */
export const NO_CONTENT_ERROR = 'No content was provided for toaster';

/**
 * The error thrown when the content passed is not a valid React element.
 */
export const INVALID_CONTENT_TYPE_ERROR = 'Toasts must be valid React elements.';

/**
 * The base styles for an individual toast.
 */
export const BASE_TOAST_STYLE = {
    position: 'absolute',
    transition: '.5s',
    opacity: 0
};
